import { Add, EditRounded } from "@mui/icons-material";
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { getPromoCodeApi } from "store/api";

import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Grid2 from "@mui/material/Unstable_Grid2";
// import PromoCode from "..";
import moment from "moment";
import AddPromoCode from "../AddPromoCode";
import { createPromoCodeApi } from "store/api";
import Success from "components/Success";
import { updatePromoCodeApi } from "store/api";
const PromoTab = () => {
  const theme = useTheme();
  const [promoCodes, setPromoCodes] = useState([]);
  const [errStatus, setErrStatus] = useState(false);
  const [msgColor, setMsgColor] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [openAdd, setOpenAdd] = useState(false);
  const [value, setValue] = React.useState(0);
  const [success, setSuccess] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const today = moment().format("YYYY-MM-DD");
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  const [promoCodeData, setPromoCodeData] = React.useState({
    code: "",
    discountType: "",
    discountValue: "",
    minOrderAmount: "",
    maxDiscountAmount: "",
    startDate: today,
    endDate: moment().add(1, "days").format("YYYY-MM-DD"),
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const FetchPromoCodeList = async () => {
    const response = await getPromoCodeApi();
    if (response?.success) {
      setPromoCodes(response?.data);
    }
  };

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChangePromo = e => {
    setErrStatus(false);
    setErrMsg("");
    setMsgColor("");
    const { name, value } = e.target;
    if (name == "startDate") {
      setPromoCodeData(prev => ({
        ...prev,
        [name]: value,
      }));

      // Ensure end date is at least 1 day after the start date
      let minEndDate = moment(value).add(1, "days").format("YYYY-MM-DD");

      // If the current end date is before the minimum allowed, update it
      if (moment(promoCodeData?.endDate).isBefore(minEndDate)) {
        setPromoCodeData(prev => ({
          ...prev,
          ["endDate"]: minEndDate,
        }));
      }
      return;
    }
    if (name == "endDate") {
      setPromoCodeData(prev => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setPromoCodeData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e?.preventDefault();
    if (!promoCodeData?.code || promoCodeData?.code.length < 9) {
      setErrStatus(true);
      setErrMsg("Promo code must be at least 9 characters long.");
      setMsgColor("red");
      return;
    }
    promoCodeData.startDate = String(moment(promoCodeData?.startDate).valueOf());
    promoCodeData.endDate = String(moment(promoCodeData?.endDate).valueOf());
    const response = await createPromoCodeApi(promoCodeData);
    if (response?.response?.data) {
      setErrStatus(true);
      setErrMsg(response?.response?.data?.message[0]);
      setMsgColor("red");
      return;
    }
    if (response?.success) {
      setMsg("Promocode successfully created.");
      setSuccess(true);
      setOpenSuccess(true);
      setOpenAdd(false);
      FetchPromoCodeList();
    } else {
      setMsg("Something went wrong. Please try again after sometime.");
      setSuccess(false);
      setOpenSuccess(true);
    }
  };

  useEffect(() => {
    FetchPromoCodeList();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Promo Code</Typography>
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Create New
        </Button>
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Promo Code' {...a11yProps(0)} />
            <Tab label='Active Promo Code' {...a11yProps(1)} />
            <Tab label='Disable Promo Code' {...a11yProps(2)} />
            {/* <Tab label='Expired Promo Code' {...a11yProps(2)} /> */}
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {promoCodes?.length == 0 && <div>No Promocode found</div>}
            {promoCodes?.length > 0 &&
              promoCodes?.map(e => (
                <PromoCodeCard
                  promocode={e}
                  setMsg={setMsg}
                  setSuccess={setSuccess}
                  setOpenSuccess={setOpenSuccess}
                  FetchPromoCodeList={FetchPromoCodeList}
                />
              ))}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {promoCodes?.length > 0 &&
              promoCodes?.map(
                e =>
                  e?.isActive && (
                    <PromoCodeCard
                      promocode={e}
                      setMsg={setMsg}
                      setSuccess={setSuccess}
                      setOpenSuccess={setOpenSuccess}
                      FetchPromoCodeList={FetchPromoCodeList}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {promoCodes?.length > 0 &&
              promoCodes?.map(
                e =>
                  !e?.isActive && (
                    <PromoCodeCard
                      promocode={e}
                      setMsg={setMsg}
                      setSuccess={setSuccess}
                      setOpenSuccess={setOpenSuccess}
                      FetchPromoCodeList={FetchPromoCodeList}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        {/* <TabPanel value={value} index={3} dir={theme.direction}>
          3
        </TabPanel> */}
      </Box>
      <AddPromoCode
        open={openAdd}
        errMsg={errMsg}
        msgColor={msgColor}
        errStatus={errStatus}
        promoCodeData={promoCodeData}
        handleClose={handleCloseAdd}
        handleSubmit={handleSubmit}
        handleChange={handleChangePromo}
      />
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </div>
  );
};

export default PromoTab;

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const PromoCodeCard = ({ promocode, setMsg, setSuccess, setOpenSuccess, FetchPromoCodeList }) => {
  const [openLoader, setOpenLoader] = useState(false);

  const handleChangePublish = async e => {
    let data = {
      code: e?.code,
      isActive: !e?.isActive,
    };
    setOpenLoader(true);
    if (data?.code) {
      const response = await updatePromoCodeApi(data);
      if (response?.success) {
        setMsg(e?.isActive ? "Promocode disabled successfully" : "Promocode active successfully");
        setOpenSuccess(true);
        setSuccess(true);
        FetchPromoCodeList();
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
    }
    setOpenLoader(false);
  };
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card style={{ position: "relative", color: "#344767" }}>
        <Stack spacing={2} sx={{ p: 3 }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", textTransform: "capitalize", textAlign: "center" }}
            noWrap
          >
            <b>Type: </b>{" "}
            {promocode?.discountType == "percentage" ? "percent(%)" : promocode?.discountType}
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{
              fontSize: "0.875rem",
              fontWeight: "500",
              backgroundColor: "#c4c4c4",
              textAlign: "center",
              borderRadius: "12px",
              padding: "10px 0",
            }}
            noWrap
          >
            {promocode?.code}
          </Box>
          <Box>
            {/* <Typography variant='h6' sx={{ fontWeight: "bold" }}>
              
            </Typography> */}
            <div
              style={{
                display: "flex",
                gap: "8px",
                fontSize: "14px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div>
                <b>Status:</b>
              </div>
              <div
                style={
                  promocode?.isActive
                    ? {
                        borderRadius: "5px",
                        backgroundColor: "green",
                        width: "10px",
                        height: "10px",
                      }
                    : {
                        borderRadius: "5px",
                        backgroundColor: "red",
                        width: "10px",
                        height: "10px",
                      }
                }
              ></div>
              <div>{promocode?.isActive ? "Active" : "Disable"}</div>
              <Tooltip title={promocode?.isActive ? "Disable" : "Active"}>
                <PublishSwitch
                  onChange={() => handleChangePublish(promocode)}
                  value={!promocode?.isActive}
                  inputProps={{ "aria-label": "controlled" }}
                  checked={promocode?.isActive}
                />
              </Tooltip>
              <Backdrop
                sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                open={openLoader}
              >
                <CircularProgress color='inherit' />
              </Backdrop>
            </div>
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", marginTop: "4px" }}
            noWrap
          >
            <b>Discount {promocode?.discountType == "percentage" ? "Percentage" : "Value"}: </b>{" "}
            {promocode?.discountType == "percentage"
              ? promocode?.discountValue + "%"
              : "₴" + promocode?.discountValue}
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "" }}
            noWrap
          >
            <b>Start Date: </b> {moment(parseInt(promocode?.startDate)).format("ll")}
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "" }}
            noWrap
          >
            <b>End Date: </b> {moment(parseInt(promocode?.endDate)).format("ll")}
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "" }}
            noWrap
          >
            <b>Max Discount Amount: </b> ₴{promocode?.maxDiscountAmount}
          </Box>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "" }}
            noWrap
          >
            <b>Min Order Amount: </b> ₴{promocode?.minOrderAmount}
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};

const PublishSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    height: 18,
    width: 38,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 18,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 9,
      marginTop: -1,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
      marginTop: -1,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
  },
}));
